import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { FormControl } from "@angular/forms";
import { DropdownPosition } from "@ng-select/ng-select";

@Component({
  selector: "lib-dropdown",
  templateUrl: "./dropdown.component.html",
  styleUrls: ["./dropdown.component.scss"],
  changeDetection: ChangeDetectionStrategy.Default
})
export class DropdownComponent {
  @Input() control: FormControl | null = null;
  @Input() isRequired = false;
  @Input() clearable = false;
  @Input() closeOnSelect = true;
  @Input() searchable = false;
  @Input() readonly = false;
  @Input() multiple = false;
  @Input() dropdownPosition: DropdownPosition = "auto";
  @Input() label = "";
  @Input() bindLabel = "";
  @Input() bindValue = "";
  @Input() bindHighlighted = "";
  @Input() groupBy = "";
  @Input() placeholder = "";
  @Input() items = [];
  @Input() lockedItems = [];
  @Input() cssClass = "";

  @Input() set appendOptionsToBody(value: boolean) {
    this.appendOptionsTo = value ? "body" : null;
  }

  @Output() change = new EventEmitter();

  private appendOptionsTo: "body" | null = null;

  get appendTo(): string {
    return <string>this.appendOptionsTo;
  }

  isItemLocked(item: any): boolean {
    if (this.lockedItems.length) {
      return this.lockedItems.some((lockedItem) =>
        this.bindValue ? item[this.bindValue] === lockedItem[this.bindValue] : item === lockedItem
      );
    }

    return false;
  }

  onChangeHandler(event: any): void {
    if (!this.multiple || !this.lockedItems.length) {
      this.change.emit(event);
      return;
    }

    const currentValue = this.control?.value || [];
    const lockedItemsNotInSelection = this.lockedItems.filter((lockedItem) => {
      if (this.bindValue) {
        const lockedValue = lockedItem[this.bindValue];
        return !currentValue.some((item: any) => item[this.bindValue] === lockedValue);
      }
      return !currentValue.includes(lockedItem);
    });

    if (lockedItemsNotInSelection.length > 0) {
      const updatedSelection = [...currentValue, ...lockedItemsNotInSelection];
      this.control?.setValue(updatedSelection);
    }

    this.change.emit(event);
  }
}
